import React from 'react';
import PartSuccess from 'assets/scanResults/FoundThreat.svg';
import Failed from 'assets/scanResults/MissedThreat.svg';
import NoThreat from 'assets/scanResults/NoThreat.svg';
import Success from 'assets/scanResults/Success.svg';
import { createUseStyles } from 'react-jss';
import { Theme } from 'helpers/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  noThreat: {
    fill: '#454545',
    flexShrink: 0
  },
  missedThreat: {
    fill: '#BD2C2C',
    flexShrink: 0
  },
  partSuccess: {
    fill: '#B18124',
    flexShrink: 0
  },
  foundThreat: {
    fill: '#1FBF2F',
    flexShrink: 0
  }
}));

export enum ThreatResult {
  ThreatPositive = 'threat:positive',
  ThreatSearched = 'threat:searched',
  ThreatCleared = 'threat:cleared',
  NoThreatPositive = 'no_threat:positive',
  NoThreatSearched = 'no_threat:searched',
  NoThreatCleared = 'no_threat:cleared',
  AlwaysPositive = 'always:positive',
  AlwaysSearched = 'always:searched',
  AlwaysCleared = 'always:cleared'
}

export enum SuccessStatus {
  Correct = 'correct',
  Incorrect = 'incorrect',
  PartlyCorrect = 'partly_correct'
}

export function getStatusInfo(status?: string) {
  const styles = useStyles();

  let threatText = 'No threat';
  let threatIcon = <img src={Success} className={styles.noThreat} />;
  let correctStatus = SuccessStatus.Correct;

  // console.log('Status', status);
  switch (status) {
    case ThreatResult.ThreatPositive:
      threatIcon = <img src={Success} className={styles.foundThreat} />;
      threatText = 'Threat identified';
      correctStatus = SuccessStatus.Correct;
      break;
    case ThreatResult.ThreatSearched:
      threatIcon = <img src={PartSuccess} className={styles.partSuccess} />;
      threatText = 'Searched, found threat';
      correctStatus = SuccessStatus.PartlyCorrect;
      break;
    case ThreatResult.ThreatCleared:
      threatIcon = <img src={Failed} className={styles.missedThreat} />;
      threatText = 'Missed threat';
      correctStatus = SuccessStatus.Incorrect;
      break;
    case ThreatResult.NoThreatPositive:
      threatIcon = <img src={Failed} className={styles.missedThreat} />;
      threatText = 'No threat present';
      correctStatus = SuccessStatus.Incorrect;
      break;
    case ThreatResult.NoThreatSearched:
      threatIcon = <img src={Failed} className={styles.missedThreat} />;
      threatText = 'Searched, no threat';
      correctStatus = SuccessStatus.Incorrect;
      break;
    case ThreatResult.NoThreatCleared:
      threatIcon = <img src={NoThreat} className={styles.noThreat} />;
      threatText = 'No threat';
      correctStatus = SuccessStatus.Correct;
      break;
    case ThreatResult.AlwaysPositive:
      threatIcon = <img src={PartSuccess} className={styles.partSuccess} />;
      threatText = 'Should search high density items';
      correctStatus = SuccessStatus.PartlyCorrect;
      break;
    case ThreatResult.AlwaysSearched:
      threatIcon = <img src={Success} className={styles.partSuccess} />;
      threatText = 'Searched item';
      correctStatus = SuccessStatus.Correct;
      break;
    case ThreatResult.AlwaysCleared:
      threatIcon = <img src={Failed} className={styles.missedThreat} />;
      threatText = 'Should search high density items';
      correctStatus = SuccessStatus.Incorrect;
      break;
  }

  let correctText = 'Correct';
  let correctColor = '#1FBF2F';
  switch (correctStatus) {
    case SuccessStatus.Correct:
      correctText = 'Correct';
      break;
    case SuccessStatus.Incorrect:
      correctText = 'Incorrect';
      break;
    case SuccessStatus.PartlyCorrect:
      correctText = 'Partly Correct';
      break;
  }

  return { threatText, threatIcon, correctText, correctColor };
}
